/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import './Card.scss';

import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

import cx from 'utils/cx';

const Card = ({
  to,
  className,
  children,
  toggleLike,
  onClick,
  isExternalLink,
  ...rest
}) => {
  const ref = useRef();

  const isLikeClicked = (e) => {
    const element = ref.current.querySelector('.like');

    if (element?.contains(e.target)) {
      e.preventDefault();
      toggleLike();
    } else {
      onClick(e);
    }
  };

  if (isExternalLink) {
    return (
      <a
        ref={ref}
        className={cx('card', className)}
        onClick={isLikeClicked}
        href={`https://tutorhive.kr${to}`}
        target="_blank"
        rel="noopener noreferrer"
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      ref={ref}
      className={cx('card', className)}
      onClick={isLikeClicked}
      to={to}
      {...rest}
    >
      {children}
    </Link>
  );
};

Card.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  toggleLike: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  isExternalLink: PropTypes.bool,
};

Card.defaultProps = {
  to: '#',
  className: null,
  onClick: () => {},
  isExternalLink: false,
};

export default Card;
